import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      "backToDashboard": "Back to Dashboard",
      "backToLists": "Back to Lists",
      "logout": "Logout",
      
      // Common
      "admin": "Admin",
      "email": "Email",
      "name": "Name",
      "loading": "Loading...",
      "save": "Save Changes",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "view": "View",
      "reset": "Reset",
      
      // Dashboard
      "welcomeBack": "Welcome back, {{name}}",
      "trackMatches": "Track your matches, check invites, and climb the rankings",
      "myRankings": "My Rankings",
      "yourEloScores": "Your ELO scores",
      "viewRankings": "View Rankings",
      "browseAllLists": "Browse all lists",
      "challengePlayer": "Challenge Player",
      "sendInvite": "Send invite",
      "profile": "Profile",
      "updateInfo": "Update info",
      "pendingInvites": "Pending Invites",
      "recentMatches": "Recent Matches",
      "noMatchesYet": "No matches yet. Send an invite to get started!",
      "accept": "Accept",
      "decline": "Decline",
      
      // Ranking Lists
      "rankingLists": "RANKING LISTS",
      "browseAndJoin": "Browse and join ranking lists to compete",
      "noRankingLists": "No ranking lists available yet",
      "askAdmin": "Ask an admin to create one!",
      "viewLeaderboard": "View Leaderboard",
      "join": "Join",
      "joinList": "Join List",
      "challenge": "Challenge",
      
      // Leaderboard
      "matches": "Matches",
      "players": "Players",
      "wins": "W",
      "losses": "L",
      "elo": "ELO",
      "noPlayers": "No players in this ranking list yet",
      "beFirstToJoin": "Be the first to join!",
      
      // Profile
      "yourProfile": "YOUR PROFILE",
      "profileInformation": "Profile Information",
      "security": "Security",
      "nickname": "Nickname",
      "club": "Club",
      "phone": "Phone",
      "optional": "(optional)",
      "emailCannotChange": "Email cannot be changed",
      "contactAdmin": "Contact admin to change email",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "changePassword": "Change Password",
      "minimum6Chars": "Minimum 6 characters",
      
      // Admin Dashboard
      "adminDashboard": "ADMIN DASHBOARD",
      "manageSettings": "Manage ranking lists, users, and tournament settings",
      "userManagement": "User Management",
      "noUsers": "No users found",
      "promoteToAdmin": "Promote to Admin",
      "createNewList": "Create New Ranking List",
      "rankingListName": "Ranking List Name",
      "matchFormat": "Match Format",
      "necessaryWins": "Necessary Wins",
      "createRankingList": "Create Ranking List",
      "manageRankingLists": "Manage Ranking Lists",
      "noListsCreated": "No ranking lists created yet",
      "editRankingList": "Edit Ranking List",
      "updateNameFormat": "Update the name and format of this ranking list",
      "resetRankingList": "Reset Ranking List?",
      "resetWarning": "This will delete all matches and reset all players to 1000 ELO. This action cannot be undone.",
      "resetList": "Reset List",
      "changeUserEmail": "Change User Email",
      "updateEmailFor": "Update email address for {{name}}",
      "newEmailAddress": "New Email Address",
      "updateEmail": "Update Email",
      "deleteUser": "Delete User",
      "deleteUserWarning": "This will anonymize the user as 'Deleted User' in all matches and remove their account. This action cannot be undone.",
      "deleteUserBtn": "Delete User",
      "emailLogs": "Email Logs",
      "emailsSent": "emails sent",
      "noEmailsSent": "No emails sent yet",
      "welcomeEmail": "Welcome",
      "resetEmail": "Reset",
      "sent": "Sent",
      "failed": "Failed",
      
      // Send Invite
      "challengeAPlayer": "CHALLENGE A PLAYER",
      "sendMatchInvite": "Send a match invite to another player",
      "searchPlayer": "Search Player by Name or Email",
      "searchByNameEmail": "Search by name or email...",
      "selectedPlayer": "Selected Player:",
      "selectRankingList": "Select Ranking List",
      "chooseRankingList": "Choose a ranking list",
      "sendChallenge": "Send Challenge",
      
      // Match Score
      "matchDetails": "MATCH DETAILS",
      "matchScore": "Match Score",
      "player1": "Player 1",
      "player2": "Player 2",
      "submitScore": "Submit Score",
      "confirmScore": "Confirm Score",
      "declineScore": "Decline Score",
      "scoreEnteredConfirm": "Score entered: {{score}}. Please confirm",
      "matchConfirmed": "Match Confirmed!",
      "rankingsUpdated": "Rankings have been updated",
      "waitingConfirmation": "Waiting for opponent to confirm score",
      
      // My Rankings
      "myRankingsPage": "MY RANKINGS",
      "performanceAcrossLists": "Your performance across all ranking lists",
      "notJoinedYet": "You haven't joined any ranking lists yet",
      "yourElo": "Your ELO",
      
      // Landing Page
      "heroTitle": "COMPETE. RANK. DOMINATE.",
      "heroSubtitle": "ELO-based tournament ranking system for competitive players. Track your performance, challenge opponents and climb the leaderboard.",
      "getStarted": "Get Started",
      "builtForCompetitors": "BUILT FOR COMPETITORS",
      "challengeOpponents": "CHALLENGE OPPONENTS",
      "challengeDesc": "Send match invites, enter scores, and confirm results with your opponents in real-time.",
      "eloRankingSystem": "ELO RANKING SYSTEM",
      "eloDesc": "Fair and accurate ranking algorithm that rewards skill and consistency over time.",
      "multipleCategories": "MULTIPLE CATEGORIES",
      "categoriesDesc": "Join different ranking lists for various games and compete across multiple categories.",
      "readyToCompete": "READY TO COMPETE?",
      "joinNowText": "Join now and start climbing the ranks",
      "joinNow": "Join Now",
      
      // Auth
      "tournamentRank": "TOURNAMENT RANK",
      "loginOrCreate": "Login or create your account",
      "authentication": "Authentication",
      "enterDetails": "Enter your details to continue",
      "login": "Login",
      "register": "Register",
      "password": "Password",
      "continueWithGoogle": "Continue with Google",
      "orContinueWith": "Or continue with",
      
      // Forgot Password
      "forgotPassword": "Forgot Password?",
      "forgotPasswordDescription": "Enter your email address and we'll send you a link to reset your password.",
      "sendResetLink": "Send Reset Link",
      "sending": "Sending...",
      "checkYourEmail": "Check Your Email",
      "resetEmailSent": "Password reset email sent!",
      "resetEmailSentDescription": "We've sent you an email with a link to reset your password. Please check your inbox.",
      "resetEmailError": "Failed to send reset email",
      "backToLogin": "Back to Login",
      
      // Reset Password
      "resetPassword": "Reset Password",
      "resetPasswordDescription": "Enter your new password below.",
      "invalidResetToken": "Invalid or missing reset token",
      "passwordMinLength": "Password must be at least 6 characters",
      "passwordsDoNotMatch": "Passwords do not match",
      "resetting": "Resetting...",
      "passwordResetSuccess": "Password reset successfully!",
      "passwordResetError": "Failed to reset password",
      "passwordChanged": "Password Changed",
      "passwordChangedDescription": "Your password has been successfully changed. You can now login with your new password.",
      "goToLogin": "Go to Login",
      
      // Toasts
      "welcomeBackToast": "Welcome back!",
      "accountCreated": "Account created successfully!",
      "loginFailed": "Login failed",
      "profileUpdated": "Profile updated successfully",
      "passwordChanged": "Password changed successfully",
      "listCreated": "Ranking list created successfully!",
      "listUpdated": "Ranking list updated!",
      "listReset": "{{name}} has been reset!",
      "inviteSent": "Match invite sent!",
      "challengeSent": "Challenge sent to {{name}}!",
      "inviteAccepted": "Invite accepted! Match created",
      "scoreEntered": "Score entered! Waiting for opponent confirmation",
      "scoreConfirmed": "Score confirmed! Rankings updated",
      "userPromoted": "{{name}} promoted to admin!",
      "userDemoted": "{{name}} is now a regular user",
      "userDeleted": "User deleted and anonymized",
      "emailUpdated": "Email updated successfully!",
      "deletionRequestSent": "Deletion request sent to administrators",
      "clubCreated": "Club created successfully!",
      "clubDeleted": "Club deleted",
      
      // New features
      "clubManagement": "Club Management",
      "addClub": "Add Club",
      "newClubName": "New club name",
      "noClubsYet": "No clubs created yet. Players must select a club when registering.",
      "runningUntil": "Running Until (optional)",
      "runningUntilHint": "After this date, the list will be locked and no new matches can be played.",
      "publicList": "Public (visible without login)",
      "locked": "Locked",
      "public": "Public",
      "until": "Until",
      "listLocked": "This ranking list has ended",
      "listLockedDesc": "No new matches can be played. Final rankings are shown below.",
      "selectYourClub": "Select your club",
      "privacyAccept": "I accept the Privacy Policy and agree to the processing of my personal data",
      "privacyRequired": "You must accept the privacy policy to register",
      "deleteAccount": "Delete Account",
      "deleteAccountDesc": "Request deletion of your account. An administrator will review your request and process it. Your match history will be anonymized.",
      "requestAccountDeletion": "Request Account Deletion",
      "deletionReason": "Reason for deletion (optional)",
      "deletionReasonPlaceholder": "Tell us why you want to delete your account...",
      "submitRequest": "Submit Request",
      "info": "Info",
      "rankingListInfo": "Ranking List Information",
      "description": "Description",
      "noDescription": "No description provided for this ranking list.",
      
      // Additional UI strings
      "notifications": "Notifications",
      "noNewNotifications": "No new notifications",
      "approveDeletion": "Approve Deletion?",
      "approveDeletionDesc": "This will permanently delete the user's account and anonymize their match history.",
      "approve": "Approve",
      "deny": "Deny",
      "pendingDeletionRequests": "Pending Deletion Requests",
      "reason": "Reason",
      "notProvided": "Not provided",
      "uploadLogo": "Upload Logo",
      "descriptionOptional": "Description (optional)",
      "authenticating": "Authenticating...",
      "loadingDashboard": "Loading dashboard...",
      "loadingList": "Loading ranking list...",
      "accessDenied": "Access Denied",
      "superAdminOnly": "This page is restricted to the super administrator only.",
      "backToHome": "Back to Home",
      "joined": "Joined",
      "enterInfoForUsers": "Enter information for all users...",
      "noAnnouncements": "No announcements",
      "databaseViewer": "Database Viewer",
      "viewPublicLists": "View public ranking lists. Login to join and compete!",
      "necessaryWins": "Necessary Wins",
      "necessaryWinsHint": "Number of wins needed to win a match (e.g., 3 for best of 5)",
      "invalidScore": "Invalid score",
      "hideDeletedUsers": "Hide deleted users",
      "deleteRankingList": "Delete Ranking List?",
      "deleteListWarning": "This will permanently delete this ranking list and ALL associated matches. This action cannot be undone.",
      "deleteList": "Delete List",
      "challengeLimitReached": "Challenge limit reached",
      "challengedAt": "Challenged",
      "confirmedAt": "Confirmed",
      "downloadReport": "Download Report",
      "reportDownloaded": "Report downloaded successfully!",
      "allMatches": "All Matches",
      "allMatchesDesc": "View all matches across all ranking lists",
      "viewAllMatches": "Browse matches",

      // Club Leaderboard
      "clubLeaderboard": "Club Leaderboard",
      "clubLeaderboardDesc": "Which club dominates the rankings?",
      "clubRanking": "Club ranking",
      "avgElo": "Avg ELO",
      "wins": "Wins",
      "winRate": "Win %",
      "members": "Members",
      "failedToLoadLeaderboard": "Failed to load leaderboard",
      "matchesFor": "Matches for",
      "createdAt": "Created",
      "lastLogin": "Last login",
      "loggedInUsers": "Online Users",
      "activeUsers": "active users",
      "noActiveUsers": "No users currently online",
      
      // Club Admin
      "clubAdmin": "Club Admin",
      "makeClubAdmin": "Club Admin",
      "assignClubAdmin": "Assign Club Admin",
      "currentlyClubAdminOf": "Currently club admin of: {{club}}",
      "selectClubForAdmin": "Select a club for {{name}} to manage",
      "assigned": "Assigned",
      "removeClubAdmin": "Remove Club Admin",
      "clubRanking": "Club Ranking",
      "forClub": "For Club: {{club}}",
      "clubRestrictedRanking": "This ranking is restricted to members of {{club}}",
      "noClubRestriction": "No club restriction (open to all)",
      "clubRankingHint": "If selected, only members of this club can join this ranking",
      "optional": "optional",
      "noClubOption": "No Club (Public rankings only)",
      "noClubHint": "Users without a club can only participate in public rankings",
      "clubMembers": "Club Members",
      "members": "members",
      "noMembersYet": "No members in this club yet",
      "kickMember": "Remove",
      "kickMemberTitle": "Remove Member from Club",
      "kickMemberWarning": "Are you sure you want to remove {{name}} from {{club}}? They will only be able to participate in public rankings afterwards.",
      
      // Login Page additional
      "ranking": "Ranking",
      "trackEloCompete": "Track your ELO and compete",
      "welcome": "Welcome",
      "signInOrCreate": "Sign in or create your account",
      "signingIn": "Signing in...",
      "signIn": "Sign In",
      "createAccount": "Create Account",
      "creatingAccount": "Creating account...",
      "noClubsAvailable": "No clubs available. Please contact an administrator.",
      "privacyPolicyText": "I accept the privacy policy and agree to the processing of my data",
      "orContinueWithLower": "or continue with",
      "continueGoogle": "Continue with Google",
      "registrationSuccess": "Account created successfully! Please login with your credentials.",
      
      // Profile Page additional
      "profileInformationTab": "Profile Information",
      "securityTab": "Security",
      "myClubs": "My Clubs",
      "myCurrentClubs": "My Current Clubs",
      "pendingRequests": "Pending Requests",
      "awaitingApproval": "Awaiting approval",
      "joinAnotherClub": "Join Another Club",
      "joinClubDescription": "Request to join additional clubs. A club administrator must approve your request.",
      "requestToJoin": "Request",
      "alreadyInAllClubs": "You are already a member of all available clubs",
      "clubJoinRequests": "Club Join Requests",
      "approve": "Approve",
      "reject": "Reject",
      "noRequests": "No pending requests",
      "online": "Online",
      "offline": "Offline",
      "playerOffline": "Player is offline",
      "challenged": "Challenged",
      "confirmed": "Confirmed",
      "save": "Save Changes",
      "saving": "Saving...",
      "changingPassword": "Changing...",
      "deleteAccount": "Delete Account",
      "deleteAccountDescription": "Request deletion of your account. An administrator will review your request and process it. Your match history will be anonymized."
    }
  },
  de: {
    translation: {
      // Navigation
      "backToDashboard": "Zurück zum Dashboard",
      "backToLists": "Zurück zu Listen",
      "logout": "Abmelden",
      
      // Common
      "admin": "Admin",
      "email": "E-Mail",
      "name": "Name",
      "loading": "Wird geladen...",
      "save": "Änderungen speichern",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "view": "Ansehen",
      "reset": "Zurücksetzen",
      
      // Dashboard
      "welcomeBack": "Willkommen zurück, {{name}}",
      "trackMatches": "Verfolgen Sie Ihre Matches, prüfen Sie Einladungen und erklimmen Sie die Rangliste",
      "myRankings": "Meine Rankings",
      "yourEloScores": "Ihre ELO-Wertungen",
      "viewRankings": "Rankings ansehen",
      "browseAllLists": "Alle Listen durchsuchen",
      "challengePlayer": "Challenge",
      "sendInvite": "Einladung senden",
      "profile": "Profil",
      "updateInfo": "Info aktualisieren",
      "pendingInvites": "Ausstehende Einladungen",
      "recentMatches": "Letzte Matches",
      "noMatchesYet": "Noch keine Matches. Senden Sie eine Einladung, um zu beginnen!",
      "accept": "Annehmen",
      "decline": "Ablehnen",
      
      // Ranking Lists
      "rankingLists": "RANGLISTEN",
      "browseAndJoin": "Ranglisten durchsuchen und beitreten, um zu konkurrieren",
      "noRankingLists": "Noch keine Ranglisten verfügbar",
      "askAdmin": "Bitten Sie einen Admin, eine zu erstellen!",
      "viewLeaderboard": "Bestenliste ansehen",
      "join": "Beitreten",
      "joinList": "Liste beitreten",
      "challenge": "Herausfordern",
      
      // Leaderboard
      "matches": "Spiele",
      "players": "Spieler",
      "wins": "S",
      "losses": "N",
      "elo": "ELO",
      "noPlayers": "Noch keine Spieler in dieser Rangliste",
      "beFirstToJoin": "Seien Sie der Erste, der beitritt!",
      
      // Profile
      "yourProfile": "IHR PROFIL",
      "profileInformation": "Profilinformationen",
      "security": "Sicherheit",
      "nickname": "Spitzname",
      "club": "Verein",
      "phone": "Telefon",
      "optional": "(optional)",
      "emailCannotChange": "E-Mail kann nicht geändert werden",
      "contactAdmin": "Kontaktieren Sie den Admin, um die E-Mail zu ändern",
      "currentPassword": "Aktuelles Passwort",
      "newPassword": "Neues Passwort",
      "confirmPassword": "Neues Passwort bestätigen",
      "changePassword": "Passwort ändern",
      "minimum6Chars": "Mindestens 6 Zeichen",
      
      // Admin Dashboard
      "adminDashboard": "ADMIN-DASHBOARD",
      "manageSettings": "Ranglisten, Benutzer und Turniereinstellungen verwalten",
      "userManagement": "Benutzerverwaltung",
      "noUsers": "Keine Benutzer gefunden",
      "promoteToAdmin": "Zum Admin befördern",
      "createNewList": "Neue Rangliste erstellen",
      "rankingListName": "Name der Rangliste",
      "matchFormat": "Spielformat",
      "createRankingList": "Rangliste erstellen",
      "manageRankingLists": "Ranglisten verwalten",
      "noListsCreated": "Noch keine Ranglisten erstellt",
      "editRankingList": "Rangliste bearbeiten",
      "updateNameFormat": "Name und Format dieser Rangliste aktualisieren",
      "resetRankingList": "Rangliste zurücksetzen?",
      "resetWarning": "Dies löscht alle Matches und setzt alle Spieler auf 1000 ELO zurück. Diese Aktion kann nicht rückgängig gemacht werden.",
      "resetList": "Liste zurücksetzen",
      "changeUserEmail": "Benutzer-E-Mail ändern",
      "updateEmailFor": "E-Mail-Adresse für {{name}} aktualisieren",
      "newEmailAddress": "Neue E-Mail-Adresse",
      "updateEmail": "E-Mail aktualisieren",
      "deleteUser": "Benutzer löschen",
      "deleteUserWarning": "Dies wird den Benutzer in allen Matches als 'Gelöschter Benutzer' anonymisieren und sein Konto entfernen. Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteUserBtn": "Benutzer löschen",
      "emailLogs": "E-Mail-Protokoll",
      "emailsSent": "E-Mails gesendet",
      "noEmailsSent": "Noch keine E-Mails gesendet",
      "welcomeEmail": "Willkommen",
      "resetEmail": "Zurücksetzen",
      "sent": "Gesendet",
      "failed": "Fehlgeschlagen",
      "necessaryWins": "Notwendige Siege",
      
      // Send Invite
      "challengeAPlayer": "EINEN SPIELER HERAUSFORDERN",
      "sendMatchInvite": "Senden Sie eine Match-Einladung an einen anderen Spieler",
      "searchPlayer": "Spieler nach Name oder E-Mail suchen",
      "searchByNameEmail": "Nach Name oder E-Mail suchen...",
      "selectedPlayer": "Ausgewählter Spieler:",
      "selectRankingList": "Rangliste auswählen",
      "chooseRankingList": "Wählen Sie eine Rangliste",
      "sendChallenge": "Herausforderung senden",
      
      // Match Score
      "matchDetails": "MATCH-DETAILS",
      "matchScore": "Match-Ergebnis",
      "player1": "Spieler 1",
      "player2": "Spieler 2",
      "submitScore": "Ergebnis übermitteln",
      "confirmScore": "Ergebnis bestätigen",
      "declineScore": "Ergebnis ablehnen",
      "scoreEnteredConfirm": "Ergebnis eingegeben: {{score}}. Bitte bestätigen",
      "matchConfirmed": "Match bestätigt!",
      "rankingsUpdated": "Rankings wurden aktualisiert",
      "waitingConfirmation": "Warte auf Bestätigung des Gegners",
      
      // My Rankings
      "myRankingsPage": "MEINE RANKINGS",
      "performanceAcrossLists": "Ihre Leistung in allen Ranglisten",
      "notJoinedYet": "Sie sind noch keiner Rangliste beigetreten",
      "yourElo": "Ihr ELO",
      
      // Landing Page
      "heroTitle": "KONKURRIEREN. RANKEN. DOMINIEREN.",
      "heroSubtitle": "ELO-basiertes Turnierranking-System für wettbewerbsorientierte Spieler. Verfolgen Sie Ihre Leistung, fordern Sie Gegner heraus und erklimmen Sie die Bestenliste.",
      "getStarted": "Jetzt starten",
      "builtForCompetitors": "FÜR WETTKÄMPFER GEBAUT",
      "challengeOpponents": "GEGNER HERAUSFORDERN",
      "challengeDesc": "Senden Sie Match-Einladungen, geben Sie Ergebnisse ein und bestätigen Sie Resultate in Echtzeit mit Ihren Gegnern.",
      "eloRankingSystem": "ELO-RANKING-SYSTEM",
      "eloDesc": "Fairer und präziser Ranking-Algorithmus, der Geschick und Beständigkeit im Laufe der Zeit belohnt.",
      "multipleCategories": "MEHRERE KATEGORIEN",
      "categoriesDesc": "Treten Sie verschiedenen Ranglisten für verschiedene Spiele bei und konkurrieren Sie in mehreren Kategorien.",
      "readyToCompete": "BEREIT ZU KONKURRIEREN?",
      "joinNowText": "Jetzt beitreten und die Ränge erklimmen",
      "joinNow": "Jetzt beitreten",
      
      // Auth
      "tournamentRank": "TOURNAMENT RANK",
      "loginOrCreate": "Einloggen oder Konto erstellen",
      "authentication": "Authentifizierung",
      "enterDetails": "Geben Sie Ihre Daten ein, um fortzufahren",
      "login": "Anmelden",
      "register": "Registrieren",
      "password": "Passwort",
      "continueWithGoogle": "Mit Google fortfahren",
      "orContinueWith": "Oder fortfahren mit",
      
      // Forgot Password
      "forgotPassword": "Passwort vergessen?",
      "forgotPasswordDescription": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
      "sendResetLink": "Reset-Link senden",
      "sending": "Wird gesendet...",
      "checkYourEmail": "Prüfen Sie Ihre E-Mail",
      "resetEmailSent": "Passwort-Reset-E-Mail gesendet!",
      "resetEmailSentDescription": "Wir haben Ihnen eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts gesendet. Bitte überprüfen Sie Ihren Posteingang.",
      "resetEmailError": "Fehler beim Senden der Reset-E-Mail",
      "backToLogin": "Zurück zur Anmeldung",
      
      // Reset Password
      "resetPassword": "Passwort zurücksetzen",
      "resetPasswordDescription": "Geben Sie unten Ihr neues Passwort ein.",
      "invalidResetToken": "Ungültiger oder fehlender Reset-Token",
      "passwordMinLength": "Passwort muss mindestens 6 Zeichen lang sein",
      "passwordsDoNotMatch": "Passwörter stimmen nicht überein",
      "resetting": "Wird zurückgesetzt...",
      "passwordResetSuccess": "Passwort erfolgreich zurückgesetzt!",
      "passwordResetError": "Fehler beim Zurücksetzen des Passworts",
      "passwordChanged": "Passwort geändert",
      "passwordChangedDescription": "Ihr Passwort wurde erfolgreich geändert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
      "goToLogin": "Zur Anmeldung",
      
      // Toasts
      "welcomeBackToast": "Willkommen zurück!",
      "accountCreated": "Konto erfolgreich erstellt!",
      "loginFailed": "Anmeldung fehlgeschlagen",
      "profileUpdated": "Profil erfolgreich aktualisiert",
      "passwordChanged": "Passwort erfolgreich geändert",
      "listCreated": "Rangliste erfolgreich erstellt!",
      "listUpdated": "Rangliste aktualisiert!",
      "listReset": "{{name}} wurde zurückgesetzt!",
      "inviteSent": "Match-Einladung gesendet!",
      "challengeSent": "Herausforderung an {{name}} gesendet!",
      "inviteAccepted": "Einladung angenommen! Match erstellt",
      "scoreEntered": "Ergebnis eingegeben! Warte auf Gegnerbestätigung",
      "scoreConfirmed": "Ergebnis bestätigt! Rankings aktualisiert",
      "userPromoted": "{{name}} zum Admin befördert!",
      "userDemoted": "{{name}} ist jetzt ein normaler Benutzer",
      "userDeleted": "Benutzer gelöscht und anonymisiert",
      "emailUpdated": "E-Mail erfolgreich aktualisiert!",
      "deletionRequestSent": "Löschungsanfrage an Administratoren gesendet",
      "clubCreated": "Verein erfolgreich erstellt!",
      "clubDeleted": "Verein gelöscht",
      
      // New features
      "clubManagement": "Vereinsverwaltung",
      "addClub": "Verein hinzufügen",
      "newClubName": "Neuer Vereinsname",
      "noClubsYet": "Noch keine Vereine erstellt. Spieler müssen bei der Registrierung einen Verein auswählen.",
      "runningUntil": "Läuft bis (optional)",
      "runningUntilHint": "Nach diesem Datum wird die Liste gesperrt und keine neuen Matches können gespielt werden.",
      "publicList": "Öffentlich (ohne Anmeldung sichtbar)",
      "locked": "Gesperrt",
      "public": "Öffentlich",
      "until": "Bis",
      "listLocked": "Diese Rangliste ist beendet",
      "listLockedDesc": "Es können keine neuen Matches gespielt werden. Die endgültigen Rankings werden unten angezeigt.",
      "selectYourClub": "Wählen Sie Ihren Verein",
      "privacyAccept": "Ich akzeptiere die Datenschutzrichtlinie und stimme der Verarbeitung meiner persönlichen Daten zu",
      "privacyRequired": "Sie müssen die Datenschutzrichtlinie akzeptieren, um sich zu registrieren",
      "deleteAccount": "Konto löschen",
      "deleteAccountDesc": "Beantragen Sie die Löschung Ihres Kontos. Ein Administrator wird Ihre Anfrage prüfen und bearbeiten. Ihre Match-Historie wird anonymisiert.",
      "requestAccountDeletion": "Kontolöschung beantragen",
      "deletionReason": "Grund für die Löschung (optional)",
      "deletionReasonPlaceholder": "Teilen Sie uns mit, warum Sie Ihr Konto löschen möchten...",
      "submitRequest": "Anfrage senden",
      "info": "Info",
      "rankingListInfo": "Ranglisten-Informationen",
      "description": "Beschreibung",
      "noDescription": "Keine Beschreibung für diese Rangliste vorhanden.",
      
      // Additional UI strings
      "notifications": "Benachrichtigungen",
      "noNewNotifications": "Keine neuen Benachrichtigungen",
      "approveDeletion": "Löschung genehmigen?",
      "approveDeletionDesc": "Dies wird das Benutzerkonto dauerhaft löschen und die Match-Historie anonymisieren.",
      "approve": "Genehmigen",
      "deny": "Ablehnen",
      "pendingDeletionRequests": "Ausstehende Löschanfragen",
      "reason": "Grund",
      "notProvided": "Nicht angegeben",
      "uploadLogo": "Logo hochladen",
      "descriptionOptional": "Beschreibung (optional)",
      "authenticating": "Authentifizierung...",
      "loadingDashboard": "Dashboard wird geladen...",
      "loadingList": "Rangliste wird geladen...",
      "accessDenied": "Zugriff verweigert",
      "superAdminOnly": "Diese Seite ist nur für den Super-Administrator zugänglich.",
      "backToHome": "Zurück zur Startseite",
      "joined": "Beigetreten",
      "enterInfoForUsers": "Informationen für alle Benutzer eingeben...",
      "noAnnouncements": "Keine Ankündigungen",
      "databaseViewer": "Datenbank-Ansicht",
      "viewPublicLists": "Öffentliche Ranglisten ansehen. Melden Sie sich an, um beizutreten und zu konkurrieren!",
      "necessaryWins": "Notwendige Siege",
      "necessaryWinsHint": "Anzahl der Siege, die für einen Match-Gewinn erforderlich sind (z.B. 3 für Best of 5)",
      "invalidScore": "Ungültiges Ergebnis",
      "hideDeletedUsers": "Gelöschte Benutzer ausblenden",
      "deleteRankingList": "Rangliste löschen?",
      "deleteListWarning": "Dies löscht diese Rangliste und ALLE zugehörigen Spiele dauerhaft. Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteList": "Liste löschen",
      "challengeLimitReached": "Herausforderungslimit erreicht",
      "challengedAt": "Herausgefordert",
      "confirmedAt": "Bestätigt",
      "downloadReport": "Bericht herunterladen",
      "reportDownloaded": "Bericht erfolgreich heruntergeladen!",
      "allMatches": "Alle Spiele",
      "allMatchesDesc": "Alle Spiele aus allen Ranglisten anzeigen",
      "viewAllMatches": "Spiele durchsuchen",

      // Club Leaderboard
      "clubLeaderboard": "Club Rangliste",
      "clubLeaderboardDesc": "Welcher Club dominiert die Rankings?",
      "clubRanking": "Club Wertung",
      "avgElo": "Ø ELO",
      "wins": "Siege",
      "winRate": "Siegquote",
      "members": "Mitglieder",
      "failedToLoadLeaderboard": "Rangliste konnte nicht geladen werden",
      "matchesFor": "Spiele von",
      "createdAt": "Erstellt",
      "lastLogin": "Letzter Login",
      "loggedInUsers": "Online Benutzer",
      "activeUsers": "aktive Benutzer",
      "noActiveUsers": "Keine Benutzer derzeit online",
      
      // Club Admin
      "clubAdmin": "Club-Admin",
      "makeClubAdmin": "Club-Admin",
      "assignClubAdmin": "Club-Admin zuweisen",
      "currentlyClubAdminOf": "Derzeit Club-Admin von: {{club}}",
      "selectClubForAdmin": "Wählen Sie einen Club für {{name}} zur Verwaltung",
      "assigned": "Zugewiesen",
      "removeClubAdmin": "Club-Admin entfernen",
      "clubRanking": "Club-Rangliste",
      "forClub": "Für Club: {{club}}",
      "clubRestrictedRanking": "Diese Rangliste ist auf Mitglieder von {{club}} beschränkt",
      "noClubRestriction": "Keine Club-Einschränkung (offen für alle)",
      "clubRankingHint": "Falls ausgewählt, können nur Mitglieder dieses Clubs dieser Rangliste beitreten",
      "optional": "optional",
      "noClubOption": "Kein Club (Nur öffentliche Ranglisten)",
      "noClubHint": "Benutzer ohne Club können nur an öffentlichen Ranglisten teilnehmen",
      "clubMembers": "Club-Mitglieder",
      "members": "Mitglieder",
      "noMembersYet": "Noch keine Mitglieder in diesem Club",
      "kickMember": "Entfernen",
      "kickMemberTitle": "Mitglied aus Club entfernen",
      "kickMemberWarning": "Sind Sie sicher, dass Sie {{name}} aus {{club}} entfernen möchten? Sie können danach nur noch an öffentlichen Ranglisten teilnehmen.",
      
      // Login Page additional
      "ranking": "Rangliste",
      "trackEloCompete": "Verfolgen Sie Ihre ELO und konkurrieren Sie",
      "welcome": "Willkommen",
      "signInOrCreate": "Anmelden oder Konto erstellen",
      "signingIn": "Anmeldung läuft...",
      "signIn": "Anmelden",
      "createAccount": "Konto erstellen",
      "creatingAccount": "Konto wird erstellt...",
      "noClubsAvailable": "Keine Vereine verfügbar. Bitte kontaktieren Sie einen Administrator.",
      "privacyPolicyText": "Ich akzeptiere die Datenschutzrichtlinie und stimme der Verarbeitung meiner Daten zu",
      "orContinueWithLower": "oder fortfahren mit",
      "continueGoogle": "Mit Google fortfahren",
      "registrationSuccess": "Konto erfolgreich erstellt! Bitte melden Sie sich mit Ihren Zugangsdaten an.",
      
      // Profile Page additional
      "profileInformationTab": "Profilinformationen",
      "securityTab": "Sicherheit",
      "online": "Online",
      "offline": "Offline",
      "playerOffline": "Spieler ist offline",
      "challenged": "Herausgefordert",
      "confirmed": "Bestätigt",
      "save": "Änderungen speichern",
      "saving": "Speichern...",
      "changingPassword": "Wird geändert...",
      "deleteAccount": "Konto löschen",
      "deleteAccountDescription": "Beantragen Sie die Löschung Ihres Kontos. Ein Administrator wird Ihre Anfrage prüfen und bearbeiten. Ihre Spielhistorie wird anonymisiert.",
      
      // Club Membership
      "myClubs": "Meine Clubs",
      "myCurrentClubs": "Meine aktuellen Clubs",
      "pendingRequests": "Offene Anfragen",
      "awaitingApproval": "Wartet auf Genehmigung",
      "joinAnotherClub": "Weiteren Club beitreten",
      "joinClubDescription": "Beantragen Sie die Mitgliedschaft in weiteren Clubs. Ein Club-Administrator muss Ihre Anfrage genehmigen.",
      "requestToJoin": "Anfragen",
      "alreadyInAllClubs": "Sie sind bereits Mitglied in allen verfügbaren Clubs",
      "clubJoinRequests": "Club-Beitrittsanfragen",
      "approve": "Genehmigen",
      "reject": "Ablehnen",
      "noRequests": "Keine offenen Anfragen"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'de',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;